// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__9EEB6","videoContent":"styles_videoContent__1HiLn"};